// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1V_zG","label":"CategoryService_label__apGzE","location":"CategoryService_location__CjIIQ"};